import { Component } from "react";
import { Link } from "gatsby";
import styles from "./cart-item.module.less";
import SiteConfig from "components/stores/site-configuration-store";
import {
  ProductStore,
  EventAggregator,
  extract,
  isArray,
  ECommerceHelper,
  DateHelper,
  LanguageHelper,
  createDate,
  RideStore,
  QuantitySelector,
  Icon,
} from "@parksandresorts/core";
import LinkWrapper from "components/block-elements/link-wrapper/link-wrapper";

export default class CartItem extends Component {
  constructor(props) {
    super(props);
    this.productName = props.name;
    this.productImageUrl = null;
    this.currencyDisplayName = extract(ECommerceHelper, "jetshop.currencyDisplayName");
    this.onlyValidText = extract(ECommerceHelper, "jetshop.onlyValidText");
    this.bookableProductInformation = this.getBookableInformation();
    this.expressPassLabel = SiteConfig.getLabel("CART_EXPRESSPASS_HEADING", "Tidsbokning");
    this.timePassHeading = SiteConfig.getLabel("CART_TIMEPASS_HEADING", "Entré");
    this.jetPassHeading = SiteConfig.getLabel("CART_JETPASS_HEADING", "JetPass");
    this.minimumQuantity = props.minimumQuantity;

    const foundProduct = ProductStore.products[LanguageHelper.getCurrentLocale()].find(
      (product) => product.productData && product.productData.jetshopId === this.props.jetshopId,
    );
    if (foundProduct) {
      this.productName = extract(foundProduct, "productName");
      this.productImageUrl = extract(foundProduct, "productImage.file.url");
      this.productUrl = extract(foundProduct, "productPageLink.slug");
      this.productThumbnailUrl = extract(foundProduct, "cartThumbnail.file.url");
      this.productType = extract(foundProduct, "productData.productType");
      this.forcedJetpassIds = extract(foundProduct, "forcedJetpassIds");
    }

    this.state = {
      expressPassLoaded: false,
    };
  }

  componentDidMount() {
    if (this.props.expressPass) {
      const expressPassObject = this.getTimeSlotsForJetPass();
      this.expressPass = {
        customerName: extract(this.props, "expressPass.customerName"),
        timePass: expressPassObject.timePass,
        jetPass: expressPassObject.jetPass,
      };

      this.setState({
        expressPassLoaded: true,
      });
    }
  }

  async getTimeSlotsForJetPass() {
    const extendedTimeSlots = [];
    const timeSlots = extract(this.props, "expressPass.timeSlots", []);
    for (const timeSlot of timeSlots) {
      const ride = RideStore.getRideById(timeSlot.id);
      extendedTimeSlots.push({
        ...timeSlot,
        timeSlotBegin: timeSlot.timeSlotBegin ? createDate(timeSlot.timeSlotBegin) : null,
        rideName: ride ? ride.title : "",
      });
    }

    const sortedTimeSlots = [...extendedTimeSlots].sort((a, b) => {
      if (!(a.timeSlotBegin && b.timeSlotBegin)) {
        return 0;
      }

      return a.timeSlotBegin - b.timeSlotBegin;
    });

    const toReturn = {
      timePass: null,
      jetPass: sortedTimeSlots,
    };

    if (this.forcedJetpassIds) {
      const timePasses = sortedTimeSlots.filter((item) => this.forcedJetpassIds.includes(item.id.toString()));
      const jetPasses = sortedTimeSlots.filter((item) => !this.forcedJetpassIds.includes(item.id.toString()));

      toReturn.timePass = timePasses;
      toReturn.jetPass = jetPasses;
    }

    return toReturn;
  }

  getBookableInformation() {
    if (!this.props.bookableItem) {
      return undefined;
    }

    const isFullDay = extract(this.props, "bookableItem.isFullDay");
    const timeSlotBegin = extract(this.props, "bookableItem.timeSlotBegin");
    if (!timeSlotBegin) {
      return undefined;
    }

    const begin = createDate(timeSlotBegin);

    return isFullDay
      ? `${this.onlyValidText ? this.onlyValidText + " " : ""}${DateHelper.toStringDDMonth(begin)}`
      : `${DateHelper.toStringDDMonth(begin)} ${DateHelper.toStringTimeHHMM(begin)}`;
  }

  formatProductObj(quantity = this.props.quantity) {
    return {
      productName: this.props.name,
      jetshopCartItemId: this.props.jetshopCartItemId,
      jetshopId: this.props.jetshopId,
      price: this.props.price,
      quantity: quantity,
    };
  }

  isRightBtnDisabled() {
    if (this.productType === "ReloadCardWithCardHolder") {
      return true;
    }
    if (this.productType === "ExpressPass") {
      return true;
    }
    if (this.productType === "BookableProduct") {
      return true;
    }
    if (this.props.quantity >= this.props.stockQuantity) {
      return true;
    }

    return false;
  }

  onChangeQuantity = (quantity) => {
    const incOrDecQuantity = quantity - this.props.quantity;

    if (incOrDecQuantity === -1 && (this.props.quantity === 1 || this.props.quantity === this.minimumQuantity)) {
      this.props.cartContext.deleteCartItem(this.formatProductObj());
    } else {
      this.props.cartContext.updateCartItem(
        this.formatProductObj(this.props.quantity + incOrDecQuantity),
        incOrDecQuantity,
      );
    }

    if (incOrDecQuantity === 1) {
      EventAggregator.publish("trackEvent", {
        category: "Cart",
        action: "Added to Cart",
        label: this.productName,
      });
    } else {
      EventAggregator.publish("trackEvent", {
        category: "Cart",
        action: "Removed from Cart",
        label: this.productName,
      });
    }
  };

  render() {
    return (
      <div className={styles.cartItem}>
        {this.productImageUrl && (
          <Link
            to={this.productUrl}
            className={styles.cartItem__imageWrapper}
            onClick={() =>
              EventAggregator.publish("trackEvent", {
                category: "Cart",
                action: "Clicked link",
                label: this.productName,
              })
            }
          >
            <div
              className={styles.cartItem__image}
              style={{
                backgroundImage: `url(${this.productThumbnailUrl ? this.productThumbnailUrl : this.productImageUrl})`,
              }}
            />
          </Link>
        )}
        <div className={styles.cartItem__actions}>
          <LinkWrapper
            url={this.productUrl}
            onPreNavigate={() =>
              EventAggregator.publish("trackEvent", {
                category: "Cart",
                action: "Clicked link",
                label: this.productName,
              })
            }
          >
            <div className={styles.innerWrapper}>
              <div className={styles.textWrapper}>
                <span className={styles.name}>{this.productName}</span>
                {this.bookableProductInformation && (
                  <span className={`${styles.bookableDate} p_small`}>{`(${this.bookableProductInformation})`}</span>
                )}
                {this.state.expressPassLoaded && (
                  <div className={styles.expressPassWrapper}>
                    <hr className={styles.expressPassDivider} />
                    <span className={`${styles.expressPassHeading} p_small`}>{`${this.expressPassLabel} ${
                      this.expressPass.customerName ? " - " + this.expressPass.customerName : ""
                    }`}</span>
                    {isArray(this.expressPass.timePass) && (
                      <>
                        <p className={[styles.typeOfPassHeading, "p_tiny"].join(" ")}>{this.timePassHeading}</p>
                        <ul className={styles.expressPassList}>
                          {this.expressPass.timePass.map((timeSlot) => (
                            <li key={timeSlot.id} className={`p_tiny ${styles.listItem}`}>
                              {DateHelper.toStringTimeHHMM(timeSlot.timeSlotBegin)} - {timeSlot.rideName}
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                    {isArray(this.expressPass.jetPass) && (
                      <>
                        <p className={[styles.typeOfPassHeading, "p_tiny"].join(" ")}>{this.jetPassHeading}</p>
                        <ul className={styles.expressPassList}>
                          {this.expressPass.jetPass.map((timeSlot) => (
                            <li key={timeSlot.id} className={`p_tiny ${styles.listItem}`}>
                              {DateHelper.toStringTimeHHMM(timeSlot.timeSlotBegin)} - {timeSlot.rideName}
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </div>
                )}
              </div>
              <Icon name="arrow-right" size="l" className={styles.icon} />
            </div>
          </LinkWrapper>
          {this.props.price >= 0 && (
            <>
              <div className={styles.cartItem__quantity}>
                <QuantitySelector
                  quantity={this.props.quantity}
                  maxQuantity={this.props.stockQuantity}
                  isMaxQuantityReached={this.isRightBtnDisabled()}
                  onQuantityChanged={(q) => this.onChangeQuantity(q)}
                  wrapperClassName={styles.quantityWrapper}
                  classNameLeftButton={styles.quantityLeftBtn}
                  classNameRightButton={styles.quantityRightBtn}
                  quantityClassName={styles.quantityQty}
                />
                <span className={styles.cartItem__price}>{`${Math.round(this.props.price) * this.props.quantity} ${
                  this.currencyDisplayName
                }`}</span>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}
